import axios from '.';

export default {
  loadToWallet,
  loadToWalletCrypto,
  fetchCryptoHostedUrl,
  fetchTransactionHistory,
  estimatePrice,
};

async function loadToWallet(data) {
  const response = await axios.post('/api/wallets/load_to_wallet', {
    ...data,
    amount: parseFloat(data.amount)
  });

  return response.data;
}

async function loadToWalletCrypto(data) {
  const response = await axios.post('/api/coinbase/charge', {
    amount: parseFloat(data.amount)
  });
  return response.data;
}

async function fetchCryptoHostedUrl(id) {
  const response = await axios.get(`/api/coinbase/wallet-hosted-url/${id}`);
  return response.data;
}

async function fetchTransactionHistory(config) {
  const filteredConfig = Object.fromEntries(
    Object.entries(config).filter(([_, value]) => value !== undefined && value !== null && value !== '')
  );
  return await axios.get('/api/transaction/get-transaction-details', { params: filteredConfig });
}

async function estimatePrice(data) {
  const response = await axios.post('/api/payments/estimate-price', {
    amount: parseFloat(data.amount),
    type: data.payment_method // 'card' or 'crypto'
  });
  return response.data;
}
